module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-pane-sizer"
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('small')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('small')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__small"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('medium')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('medium')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__medium"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('large')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('large')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__large"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9cbbb7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/bottomPaneSizer/BottomPaneSizer.vue
// module id = 1992
// module chunks = 0